/*
*
* File JS per il TPL Contatti
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';
import blockTextBg from 'components/block-text-background/block-text-background';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './contact-page.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const manageTab = () => {
    let blockTabs = document.querySelector('.block-howtoget__tab'); 

    if (!blockTabs) return;
    
    let allContentTab = document.querySelectorAll('.block-howtoget__tab-content > div');
    let allBtnTab = document.querySelectorAll('.block-howtoget__tab-nav ul li');
    let selectBtnTab = document.querySelector('.block-howtoget__tab-nav select');

    // Chiudi tutte le tab
    const closeAllTab = () => {
        allContentTab.forEach(el => {
            el.classList.remove('active');
        });
        allBtnTab.forEach(el => {
            el.classList.remove('active');
        });
    }

    // Seleziona Tab in base a data-tab
    const activeTab = (id) => {
        allContentTab.forEach(el => {
            if (el.dataset.tab !== id) return;
            el.classList.add('active');
        });

        allBtnTab.forEach(el => {
            if (el.dataset.tab !== id) return;
            el.classList.add('active');
        });

        selectBtnTab.value = id;
    }

    // Event Listener ul li (Desk)
    allBtnTab.forEach(el => {
        el.addEventListener('click', (e) => {
            closeAllTab();
            activeTab(e.target.dataset.tab);
        });
    });

    // Event Listener select (Mobile)
    selectBtnTab.addEventListener('change', (e) => {
        closeAllTab();
        activeTab(e.target.value);
    })
}
manageTab();

//--------------------------------------------------------------------//